// extracted by mini-css-extract-plugin
export var menuIcon = "_sv-0";
export var menuIconInline = "_sv-1";